/**
 * size-chart-highlight.js
 *
 * Highlights the row of the size guide that matches the size the shopper has
 * actually selected on the product form.
 *
 * Why the normalisation matters: the charts write sizes as XS / S / M / L / XL,
 * while the store's variant options are almost always spelled out — "Large",
 * "Extra Large", "XX-Large", and three more spellings of XL. Footwear charts
 * carry the Y suffix on Grade School rows ("4Y") where the variant just says
 * "4". Matching on the raw strings would find almost nothing, so both sides are
 * normalised before comparison.
 *
 * The modal is moved to <body> by ModalDialog on connect, so a table can't walk
 * up to its own product form. It carries data-size-source (the section id) and
 * data-size-option (the option name) instead, and looks the picker back up.
 */
(function () {
  'use strict'

  var ALPHA = {
    XS: 'XS', 'EXTRA SMALL': 'XS', 'EXTRA-SMALL': 'XS', 'X-SMALL': 'XS', XSMALL: 'XS',
    XXS: 'XXS', 'XX-SMALL': 'XXS', 'XX SMALL': 'XXS',
    S: 'S', SMALL: 'S',
    M: 'M', MEDIUM: 'M',
    L: 'L', LARGE: 'L',
    XL: 'XL', 'EXTRA LARGE': 'XL', 'EXTRA-LARGE': 'XL', 'X-LARGE': 'XL', XLARGE: 'XL', '2XL': 'XL',
    XXL: 'XXL', 'XX-LARGE': 'XXL', 'XX LARGE': 'XXL', '2X-LARGE': 'XXL',
    XXXL: 'XXXL', 'XXX-LARGE': 'XXXL', 'XXX LARGE': 'XXXL', '3XL': 'XXXL'
  }

  function normalize(raw) {
    if (raw == null) return ''
    var t = String(raw)
      .normalize('NFKD')
      .replace(/[\u0300-\u036f]/g, '')
      .toUpperCase()
      .trim()
    // drop condition/parenthetical suffixes: "Large (Preown)", "11 preown"
    t = t.replace(/\s*\((?:PRE ?OWN\w*|USED)\)\s*$/, '').trim()
    t = t.replace(/\s+(?:PRE ?OWN\w*|USED)$/, '').trim()
    if (ALPHA[t]) return ALPHA[t]
    // footwear: "US 9" / "9.5Y" / "10C" all reduce to the number
    var n = t.replace(/^US\s*/, '').replace(/[YCW]$/, '').trim()
    if (/^\d+(\.\d+)?$/.test(n)) return String(parseFloat(n))
    return t
  }

  function selectedSize(table) {
    var sectionId = table.getAttribute('data-size-source')
    var optionName = table.getAttribute('data-size-option')
    if (!sectionId || !optionName) return null

    var picker =
      document.getElementById('variant-radios-' + sectionId) ||
      document.getElementById('variant-selects-' + sectionId)
    if (!picker) return null

    var inputs = picker.querySelectorAll('input[type="radio"]:checked')
    for (var i = 0; i < inputs.length; i++) {
      // the radio group is named after the option, sometimes with suffixes
      if (inputs[i].name === optionName || inputs[i].name.indexOf(optionName + '-') === 0) {
        return inputs[i].value
      }
    }
    return null
  }

  function paint(table) {
    var value = selectedSize(table)
    var want = normalize(value)
    var label = table.getAttribute('data-size-selected-label') || ''
    var rows = table.querySelectorAll('tbody tr')

    for (var i = 0; i < rows.length; i++) {
      var row = rows[i]
      var hit =
        want !== '' &&
        (normalize(row.getAttribute('data-size')) === want ||
          normalize(row.getAttribute('data-size-alt')) === want)

      row.classList.toggle('size-chart__row--selected', hit)
      if (hit) {
        row.setAttribute('aria-current', 'true')
        if (label && !row.querySelector('.size-chart__selected-note')) {
          var note = document.createElement('span')
          note.className = 'size-chart__selected-note visually-hidden'
          note.textContent = label
          row.firstElementChild && row.firstElementChild.appendChild(note)
        }
      } else {
        row.removeAttribute('aria-current')
        var stale = row.querySelector('.size-chart__selected-note')
        if (stale) stale.parentNode.removeChild(stale)
      }
    }
  }

  function paintAll() {
    var tables = document.querySelectorAll('[data-size-chart]')
    for (var i = 0; i < tables.length; i++) paint(tables[i])
  }

  // Repaint whenever a variant is picked. Delegated at the document level
  // because the picker and the moved modal are in different subtrees, and
  // because quick view injects new pickers after this script has run.
  document.addEventListener('change', function (e) {
    if (e.target && e.target.type === 'radio') paintAll()
  })

  // The modal is rendered up front but only revealed on click; repaint on open
  // so the row is already marked when the shopper looks at it.
  document.addEventListener('click', function (e) {
    var opener = e.target && e.target.closest && e.target.closest('modal-opener')
    if (opener) setTimeout(paintAll, 0)
  })

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paintAll)
  } else {
    paintAll()
  }

  // quick view swaps in a whole product section after load
  document.addEventListener('shopify:section:load', paintAll)
})()
